<template>
  <div class="login-box">
    <div class="top-icon">
      <img src="@/assets/logo_gold.png" @click.stop="toHome" />
    </div>
    <div class="user-pannel">
      <div class="re-title">Welcome back!</div>
      <!-- <div class="re-sub-title">Get access to millions of study documents, 24/7 tutor help, textbook solutions, and more.</div> -->
      <!-- <div class="re-status">
                <div class="re-choice" :class="{selected:statusSelected==='student'}" @click="chooseStatus('student')">I'm a student</div>
                <div class="re-choice" :class="{selected:statusSelected==='group'}" @click="chooseStatus('group')">I'm a group</div>
            </div> -->
      <el-form :model="loginForm" ref="loginForm" :rules="rules">
        <el-form-item label="Email address" prop="login_name">
          <el-input
            v-model="loginForm.login_name"
            placeholder="Enter an email address"
          ></el-input>
        </el-form-item>
        <el-form-item label="Password" prop="password">
          <a href="/#/forgotpwd">
            <span class="forgot-password">Forgot Password</span>
          </a>
          <el-input
            type="password"
            v-model="loginForm.password"
            placeholder="Enter your password"
          >
            <i
              slot="suffix"
              class="el-icon-view"
              style="margin-right: 5px"
              @mousedown="showPass($event)"
              @mouseup="hidePass($event)"
            ></i>
          </el-input>
        </el-form-item>
      </el-form>
      <el-checkbox v-model="rememberMe">Remember me</el-checkbox>
      <div class="re-login re-third" @click="login" v-loading="loginLoading">
        Log in
      </div>
      <div class="re-google re-third" @click="logInGoogle">
        <img src="@/assets/icon/google.png" />
        <div>Log in with Google</div>
      </div>
      <div class="re-facebook re-third" @click="logInFacebook">
        <img src="@/assets/icon/facebook.png" />
        <div>Log in with Facebook</div>
      </div>
      <!-- <div class="re-google re-third">
                <img :src="require('@/assets/icon/google.png')" />Log in with Google
            </div>
            <div class="re-facebook re-third">
                <img :src="require('@/assets/icon/facebook.png')" />Log in with Facebook
            </div> -->
      <div class="re-tips">
        Don't have an account? <router-link to="/registry">Sign up</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { isEmail } from "@/utils/validate";
import { Md5ChangePass, scopeDomain, secreKey } from "@/utils/comm";
import Cookies from "js-cookie";
export default {
  computed: {
    ...mapState({
      userInfo: (state) => state.app.userInfo,
    }),
  },
  created() {
    let { errCode, status, token } = this.$route.query;
    if (status === "0" && token) {
      //登录成功
      Cookies.set(scopeDomain.name, res.data.token, {
        expires: 3,
        domain: scopeDomain.path,
      }); //设置cookie
      this.$store.commit("setToken", token).then(() => {
        this.autoLogin();
      });
    }
  },
  mounted() {
    this.loginForm.login_name = Cookies.get("login_name");
    if (Cookies.get("password")) {
      let temp_p = window.atob(Cookies.get("password"));
      this.loginForm.password = temp_p.substring(temp_p.indexOf(secreKey), -1);
    }
    this.rememberMe = Cookies.get("rememberMe") === "true" ? true : false;
  },
  data() {
    var validateEmail = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("Please fill in the email."));
      } else if (!isEmail(value)) {
        callback(new Error("Please enter a valid email."));
      } else callback();
    };
    return {
      statusSelected: "student",
      loginLoading: false,
      loginForm: {
        login_name: "",
        password: "",
      },
      rememberMe: false,

      rules: {
        login_name: [
          { required: true, validator: validateEmail, trigger: "blur" },
        ],
        password: [
          {
            required: true,
            message: "Please fill in the password.",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    //自定义密码转文本显示框
    showPass: function (e) {
      let { type } = e.path[3].firstElementChild;
      e.path[3].firstElementChild.type = "text";
    },
    hidePass(e) {
      let { type } = e.path[3].firstElementChild;
      e.path[3].firstElementChild.type = "password";
    },
    //google授权登录
    logInGoogle() {
      window.location.href =
        "https://accounts.google.com/o/oauth2/v2/auth?access_type=offline&scope=https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile&response_type=code&client_id=619151573090-9k02nb4ufr9ufgla1f0brh4mm4gnd5ee.apps.googleusercontent.com&redirect_uri=https://api.coveycampus.com/api/v1.0/coveyuser/googlecallback";
    },
    //facebook授权登录
    logInFacebook() {
      window.location.href =
        "https://www.facebook.com/v13.0/dialog/oauth?client_id=633844777722082&redirect_uri=https://api.coveycampus.com/api/v1.0/coveyuser/facebookcallback";
    },
    chooseStatus(status) {
      this.statusSelected = status;
    },
    login() {
      //todo 记住密码
      this.$refs["loginForm"].validate((valid) => {
        if (!valid) return;
        try {
          Cookies.set("rememberMe", this.rememberMe);
          let data = { ...this.loginForm };
          Cookies.set("login_name", data.login_name, { expires: 7 });
          let tempPassword = window.btoa(data.password + secreKey);
          data.password = Md5ChangePass(data.password);
          this.loginLoading = true;
          this.$api.comApi.login(data).then((res) => {
            if (res.status === "0") {
              if (this.rememberMe) {
                //如果记住密码 存到cookie 7天过期
                Cookies.set("password", tempPassword, { expires: 7 });
              } else {
                Cookies.set("password", "", { expires: 7 });
              }
              //登录成功
              Cookies.set(scopeDomain.name, res.data.token, {
                expires: 3,
                domain: scopeDomain.path,
              }); //设置cookie
              this.$store.commit("setToken", res.data.token);
              this.$store.commit("handleUserInfo", res.data.userInfo || {}); // 绑定用户信息
              this.$store.commit("SET_USERINFO", res.data.userInfo || {}); // 绑定用户信息
              this.$store.commit("menuRouteLoaded", false); // 要求重新加载导航菜单
              this.$store.commit("onCallback", true);
              this.$router.push("/"); // 登录成功，跳转到对应路由
            } else {
              this.$message.error(res.message);
            }
            this.loginLoading = false;
          });
        } catch (err) {
          this.loginLoading = false;
          this.$message.error(err);
        }
      });
    },
    autoLogin() {
      this.$api.comApi.getUserInfo().then((res) => {
        if (res.status === "0") {
          this.$store.commit("handleUserInfo", res.data || {}); // 绑定用户信息
          this.$store.commit("SET_USERINFO", res.data || {}); // 绑定用户信息
          this.$store.commit("menuRouteLoaded", false); // 要求重新加载导航菜单
          this.$store.commit("onCallback", true);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    toHome() {
      this.$router.push("home");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/utils/vw.scss";
.login-box {
  min-height: 100vh;
  background: #fce9d1;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding-bottom: vw(28);
  .top-icon {
    text-align: center;
    padding: 28px;
    cursor: pointer;
    img {
      width: 113px;
      height: 40px;
    }
  }
  .user-pannel {
    width: vw(600);
    padding: vw(50) vw(120);
    // height: vw(625);
    background: #fff;
    margin-top: vw(60);
    text-align: center;
    border-radius: 24px;
    box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.04);
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    .el-form {
      margin-top: vw(16);
      width: 100%;
    }
    .el-form-item {
      margin-bottom: vw(32);
      .forgot-password {
        cursor: pointer;
        float: right;
        font-size: 14px;
        font-weight: 600;
        color: #f48c06;
        line-height: 20px;
      }
    }
    /deep/ .el-form > .el-form-item > .el-form-item__label {
      font-size: 14px;
      font-weight: 600;
      color: #201002;
      line-height: 20px;
    }
    /deep/ .el-form > .el-form-item > .el-form-item__content {
      // line-height: 100%;
      .el-input {
        margin-top: vw(8);
        .el-input__inner {
          height: vw(48);
          border-radius: 8px;
          border: 2px solid rgba(32, 16, 2, 0.32);
        }
      }
    }
    /deep/ .el-checkbox {
      width: 100%;
      text-align: left;
      color: #201002;
      font-weight: 600;
      line-height: 20px;
      font-size: 14px;
      margin-top: vw(-16);
      margin-bottom: vw(16);

      .el-checkbox__input.is-checked .el-checkbox__inner,
      .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #f48c06;
        border-color: #f48c06;
      }
      .el-checkbox__input.is-checked + .el-checkbox__label {
        color: #201002;
      }
      .el-checkbox__input.is-focus {
        .el-checkbox__inner {
          border-color: #f48c06;
        }
      }
      .el-checkbox__inner {
        &:hover {
          border-color: #f48c06;
        }
      }
    }
    .re-title {
      font-weight: 600;
      color: #201002;
      line-height: vw(66);
      font-size: vw(42);
    }
    .re-sub-title {
      margin-top: vw(16);
      font-size: vw(18);
      line-height: vw(28);
      color: #201002;
    }
    .re-status {
      display: flex;
      width: 100%;
      height: vw(48);
      font-size: 14px;
      font-weight: 600;
      text-align: center;
      border-radius: 24px;
      background: rgba(0, 0, 0, 0.04);
      margin-top: 24px;
      .re-choice {
        width: 50%;
        height: 100%;
        font-size: vw(14);
        padding: vw(14) vw(15);
        line-height: 20px;
        border-radius: 24px;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }
      .selected {
        color: #fff;
        background: #f48c06;
        transition: 0.2s;
      }
    }
    .fb-signin-button,
    .g-signin-button {
      /* This is where you control how the button looks. Be creative! */
      //   display: inline-block;
      //   padding: 4px 8px;
      //   border-radius: 3px;
      //   background-color: #4267b2;
      //   color: #fff;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .re-third {
      width: 100%;
      height: vw(48);
      font-size: vw(14);
      font-weight: 600;
      border-radius: 8px;
      margin-top: vw(16);
      cursor: pointer;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: vw(24);
        height: vw(24);
        margin-right: vw(16);
      }
      &:hover {
        // opacity: 0.54;
      }
    }
    .re-login {
      background: #f48c06;
    }
    .re-google {
      background: #5d99fb;
      margin-top: vw(32);
    }
    .re-facebook {
      background: #3b5998;
    }
    .re-email {
      background: #fa6484;
    }
    .re-tips {
      font-size: vw(18);
      font-weight: 500;
      color: #201002;
      line-height: vw(28);
      margin-top: vw(32);
      a:link {
        /* 未被访问的链接 蓝色 */
        color: #f48c06;
        text-decoration: none;
      }
      a:visited {
        color: #f48c06;
        text-decoration: none;
      } /* 已被访问过的链接 蓝色 */
      a:hover {
        color: #f48c06;
        text-decoration: none;
      } /* 鼠标悬浮在上的链接 蓝色 */
      a:active {
        color: #f48c06;
        text-decoration: none;
      } /* 鼠标点中激活链接 蓝色 */
    }
  }
}
</style>
